import { supabase, isDemoMode } from './supabase';

export async function signUp({ firstName, lastName, username, email, password }) {
  if (isDemoMode || !supabase) {
    return { data: null, error: { message: 'Sign-up is not available in demo mode. Please configure Supabase credentials.' } };
  }
  return supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        first_name: firstName,
        last_name: lastName,
        username,
        role: 'student',
      },
    },
  });
}

export async function signIn({ email, password }) {
  const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (authError) return { data: null, error: authError };

  const { data: profile, error: profileError } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', authData.user.id)
    .single();

  if (profileError) {
    await supabase.auth.signOut();
    return { data: null, error: profileError };
  }

  if (profile.role === 'student' && !profile.is_active) {
    await supabase.auth.signOut();
    return {
      data: null,
      error: { message: 'Your account is not yet active. Please contact your administrator.' },
    };
  }

  return { data: { session: authData.session, profile }, error: null };
}

export async function signOut() {
  return supabase.auth.signOut();
}

export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  return { session: data?.session ?? null, error };
}

export function onAuthStateChange(callback) {
  const { data } = supabase.auth.onAuthStateChange(callback);
  return data.subscription;
}
